"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformEntryParsedResponse = void 0;
function transformEntryParsedResponse(entry) {
    return {
        accountingSystemId: entry.accounting_systemid,
        categoryId: entry.categoryid,
        clientId: entry.clientid,
        creditId: entry.creditid,
        entryId: entry.entryid,
        expenseId: entry.expenseid,
        id: entry.id,
        incomeId: entry.incomeid,
        invoiceId: entry.invoiceid,
        paymentId: entry.paymentid,
    };
}
exports.transformEntryParsedResponse = transformEntryParsedResponse;
//# sourceMappingURL=Entry.js.map